import React, { useState } from 'react';

const ImageUploader = ({ onUpload }) => {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(null);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'unsigned_ibuyunn'); // 👈 your preset name

    try {
      const res = await fetch(`https://api.cloudinary.com/v1_1/dm8uirujp/upload`, {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();
      setPreview(data.secure_url);
      onUpload(data.secure_url); // send back the image URL
    } catch (err) {
      console.error('Upload failed:', err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-3">
      <input type="file" accept="image/*" onChange={handleImageUpload} />
      {uploading && <p>Uploading...</p>}
      {preview && <img src={preview} alt="Uploaded" className="h-32 rounded shadow" />}
    </div>
  );
};

export default ImageUploader;
